<template>
  <div>
    <img class="pointer" style="width: 100%;" src="@/assets/dashboard/banner.png" @click="$login">
    <text-left
      :text-left="{
        height: 380,
        title: '银行账户信息集中显示',
        desc: '集中列示所有银行账户信息，帮助您更好的了解企业的资金状况。',
        textWidth: 510,
        imgWidth: 500,
        left: true,
        img: require('@/assets/dashboard/img1.png')
      }"/>
    <text-left
      :text-left="{
        height: 360,
        title: '逾期账单一览无余，轻松实现快捷收付',
        desc: '集中显示销售及采购账单的收付状态，更好地管理逾期账款。点击仪表盘，可直接链接到与客户供应商的交易数据明细，由此及彼，了然于心。',
        textWidth: 540,
        left: false,
        imgWidth: 500,
        img: require('@/assets/dashboard/img2.png')
      }"/>
    <text-left
      :text-left="{
        height: 430,
        title: '深层次了解内部成本支出，帮助您的企业开源节流',
        desc: '集中显示所有费用报销单数据，点击仪表盘，可直接链接到员工的费用报销明细。同时，费用还可按照员工、金额、报销状态以及其他核算条件等进行筛选分析。',
        textWidth: 500,
        left: true,
        imgWidth: 500,
        img: require('@/assets/dashboard/img3.png')
      }"/>
    <part-list :part-list="list" />
    <Ready />
  </div>
</template>

<script>
import Ready from '@/components/Ready'
import PartList from '@/components/PartList'
import TextLeft from '@/components/TextLeft'
export default {
  name: 'Dashboard',
  components: { Ready, PartList, TextLeft },
  data() {
    return {
      list: [
        {
          img: require('@/assets/common/caiwu.png'),
          title: '财务检测助手',
          desc: '自动巡检账套，检测常见财务锗误与税务风险',
          path: '/financial'
        },
        {
          img: require('@/assets/common/yinhang.png'),
          title: '银行与业务对账',
          desc: '快速完成银行对账单与业务交易的逐笔核销和对账',
          path: '/reconciliation'
        },
        {
          img: require('@/assets/common/baobiao.png'),
          title: '报表',
          desc: '标准化报表加EXCEL自定义报表工具，满足您多元的报表需求',
          path: '/report'
        },
        {
          img: require('@/assets/common/fapiao.png'),
          title: '发票管理',
          desc: '跟踪每笔业务的发票开具或收到状态、认证和抵扣状态',
          path: '/bill'
        },
        {
          img: require('@/assets/common/duobibie.png'),
          title: '多币别核算',
          desc: '多种币别记录交易数据，跟踪汇兑收益与损失',
          path: '/currency'
        }
      ]
    }
  }
}
</script>

<style scoped>

</style>
